import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { FaFileAlt, FaCheckCircle, FaStar, FaHeadset } from 'react-icons/fa';

function Dashboard() {
  const [availableDocuments, setAvailableDocuments] = useState({
    totalUploaded: 0,
    pendingToVerify: 0,
    favourites: 0,
    supportRequests: 0,
  });
  const [monthlyUploads, setMonthlyUploads] = useState([]);
  const [totalSpent, setTotalSpent] = useState([]);
  const [profileCompletion, setProfileCompletion] = useState(0);

  useEffect(() => {
    // Placeholder for fetching data from the backend
    fetch('/api/dashboard-data')
      .then((response) => response.json())
      .then((data) => {
        setAvailableDocuments(data.availableDocuments);
        setMonthlyUploads(data.monthlyUploads);
        setTotalSpent(data.totalSpent);
        setProfileCompletion(data.profileCompletion);
      })
      .catch((error) => console.error('Error fetching dashboard data:', error));
  }, []);

  return (
    <div className="p-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
        <div className="bg-white p-4 rounded shadow w-full">
          <h2 className="text-xl font-bold mb-4">Available Documents</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-red-100 p-4 rounded flex flex-col items-center justify-center">
              <FaFileAlt className="text-2xl mb-2" />
              <p className="text-sm sm:text-base">Total Uploaded</p>
              <p className="text-xl md:text-2xl font-bold">{availableDocuments.totalUploaded}</p>
            </div>
            <div className="bg-yellow-100 p-4 rounded flex flex-col items-center justify-center">
              <FaCheckCircle className="text-2xl mb-2" />
              <p className="text-sm sm:text-base">Pending To Verify</p>
              <p className="text-xl md:text-2xl font-bold">{availableDocuments.pendingToVerify}</p>
            </div>
            <div className="bg-green-100 p-4 rounded flex flex-col items-center justify-center">
              <FaStar className="text-2xl mb-2" />
              <p className="text-sm sm:text-base">Favourites</p>
              <p className="text-xl md:text-2xl font-bold">{availableDocuments.favourites}</p>
            </div>
            <div className="bg-purple-100 p-4 rounded flex flex-col items-center justify-center">
              <FaHeadset className="text-2xl mb-2" />
              <p className="text-sm sm:text-base">Support Requests</p>
              <p className="text-xl md:text-2xl font-bold">{availableDocuments.supportRequests}</p>
            </div>
          </div>
        </div>
        <div className="bg-white p-4 rounded shadow w-full">
          <h2 className="text-xl font-bold mb-4">Monthly Uploads</h2>
          <ResponsiveContainer width="100%" height={200}>
            <LineChart data={monthlyUploads}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="value" stroke="#8884d8" activeDot={{ r: 8 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="bg-white p-4 rounded shadow w-full">
          <h2 className="text-xl font-bold mb-4">Total Spent</h2>
          <ResponsiveContainer width="100%" height={200}>
            <LineChart data={totalSpent}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="value" stroke="#82ca9d" activeDot={{ r: 8 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <div className="bg-white p-4 rounded shadow w-full">
          <h2 className="text-xl font-bold mb-4">Profile Status</h2>
          <div className="flex justify-center items-center" style={{ height: '150px' }}>
            <div style={{ width: '70%', maxWidth: '150px', maxHeight: '150px' }}>
              <CircularProgressbar
                value={profileCompletion}
                text={`${profileCompletion}%`}
                styles={buildStyles({
                  textColor: '#000',
                  pathColor: '#4caf50',
                  trailColor: '#d6d6d6',
                })}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
